import "reflect-metadata";
import {ServiceLine} from 'quote-domain-core';
import { container } from 'tsyringe';
import { ServiceLineService } from './service/service-line-service';

export class ServiceLineManager {
    constructor(private readonly serviceLineService: ServiceLineService = container.resolve(ServiceLineService)) {
    }

    public updateServiceLineAppliedPriceAndColor(serviceLine: ServiceLine): ServiceLine {
       this.serviceLineService.updateAppliedPriceAndColor(serviceLine);
       return serviceLine;
    }
}

